import React, { useState, useEffect } from 'react';
import { icons } from './ui/Icons';

/**
 * Componente: Carousel (/components/Carousel.jsx)
 * Carrossel de patrocinadores
 */
const Carousel = ({ items, onNavigate }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
    }, 5000); // Rotação automática a cada 5 segundos
    return () => clearInterval(timer);
  }, [items.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + items.length) % items.length);
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
  };

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="relative w-full max-w-7xl mx-auto rounded-xl overflow-hidden shadow-lg group" style={{ aspectRatio: '16/9', maxHeight: '300px' }}>
      <div
        className="flex transition-transform duration-700 ease-in-out h-full"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {items.map((item) => (
          <div
            key={item.id}
            className="w-full flex-shrink-0 h-full relative cursor-pointer"
            onClick={() => onNavigate('barbershop', { id: item.id })}
          >
            <img
              src={item.bannerUrl}
              alt={item.name}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-4 sm:p-6 md:p-8 lg:p-12 right-0">
              <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-5xl font-bold text-white shadow-lg line-clamp-1">{item.name}</h2>
              <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white/90 mt-1 md:mt-2 hidden sm:block max-w-lg line-clamp-2">{item.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Controles de Navegação - Menores no mobile, apenas no hover em desktop */}
      {items.length > 1 && (
        <>
          <button
            onClick={prevSlide}
            className="absolute top-1/2 left-1 sm:left-2 md:left-4 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-1 sm:p-1.5 md:p-2 transition-all shadow-md z-10 opacity-70 group-hover:opacity-100"
            aria-label="Anterior"
          >
            {icons.chevronLeft({ className: 'h-4 w-4 sm:h-5 sm:w-5 md:h-6 md:w-6 text-gray-800' })}
          </button>
          <button
            onClick={nextSlide}
            className="absolute top-1/2 right-1 sm:right-2 md:right-4 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-1 sm:p-1.5 md:p-2 transition-all shadow-md z-10 opacity-70 group-hover:opacity-100"
            aria-label="Próximo"
          >
            {icons.chevronRight({ className: 'h-4 w-4 sm:h-5 sm:w-5 md:h-6 md:w-6 text-gray-800' })}
          </button>
        </>
      )}

      {/* Indicadores */}
      <div className="absolute bottom-2 sm:bottom-3 md:bottom-4 left-1/2 -translate-x-1/2 flex space-x-1.5 sm:space-x-2 z-10">
        {items.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`rounded-full transition-all ${
              currentIndex === index ? 'bg-white w-6 sm:w-8 h-2 sm:h-2.5' : 'bg-white/50 hover:bg-white/80 w-2 h-2'
            }`}
            aria-label={`Ir para slide ${index + 1}`}
          ></button>
        ))}
      </div>
    </div>
  );
};

export default Carousel;
